<template>
  <div>
    <label
      :for="id"
      class="input__label"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-select-country
      class="margin__t--6"
      v-model="model"
      :placeholder="translate(placeholder)"
      :id="id"
      :v="validator"
    />
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { useModule } from '@/composables/app/useModule'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'

import InputSelectCountry from '&/atoms/InputSelectCountry'

const { block } = defineProps({
  block: { type: Object, required: true }
})

const procedure_execution = inject('procedure_execution')

const { translate } = useI18n()
const { id, label, model, placeholder, defaultValue } = useModule({ component: block, parent: procedure_execution, default_value: 'BE' })
const { validator } = useProcedureBlockValidator({ validations: block.mandatory, state: model })

if (!model.value && defaultValue.value) model.value = defaultValue.value
</script>
